import type { IStatusProps } from 'shared/ui/Status'
import { KnowledgeBaseDocumentStatus } from 'entities/KnowledgeBase'

const INDEXATION_CONFIG: IStatusProps = {
  title: 'Processing',
  icon: 'refreshCircle',
  emphasis: 'high',
  intent: 'informative',
}

const INDEXATION_FAILED_CONFIG: IStatusProps = {
  title: 'Failed',
  icon: 'cancelFilled',
  emphasis: 'high',
  intent: 'negative',
}

const INDEXATION_SUCCESS_CONFIG: IStatusProps = {
  title: 'Ready',
  icon: 'check2',
  emphasis: 'high',
  intent: 'positive',
}

const DRAFT_CONFIG: IStatusProps = {
  title: 'Draft',
  icon: 'draft',
  emphasis: 'high',
  intent: 'neutral',
}

const ACCESS_LOST_CONFIG: IStatusProps = {
  title: 'Access lost',
  icon: 'alertCircle',
  emphasis: 'high',
  intent: 'warning',
}

export const getKnowledgeBaseDocumentStatusConfig = (
  status: KnowledgeBaseDocumentStatus,
  isLiveDocument?: boolean
) => {
  switch (status) {
    case KnowledgeBaseDocumentStatus.Indexation:
      return INDEXATION_CONFIG
    case KnowledgeBaseDocumentStatus.IndexationSuccess:
      return INDEXATION_SUCCESS_CONFIG
    case KnowledgeBaseDocumentStatus.Complete:
      return isLiveDocument ? INDEXATION_SUCCESS_CONFIG : null
    case KnowledgeBaseDocumentStatus.IndexationFailed:
      return INDEXATION_FAILED_CONFIG
    case KnowledgeBaseDocumentStatus.Failed:
      return isLiveDocument ? ACCESS_LOST_CONFIG : INDEXATION_FAILED_CONFIG
    case KnowledgeBaseDocumentStatus.Draft:
      return DRAFT_CONFIG
    default:
      return null
  }
}
